const PairDatasetFilter = Object.freeze({
  ANY_DATASET: 'tamr__any_dataset',
  ANY_OTHER_DATASET: 'tamr__any_other_dataset',
});

export default PairDatasetFilter;
